import * as yup from 'yup';
import { email } from './baseSchema';

const ResetPasswordSchema = yup.object().shape({
  email,
});

export default ResetPasswordSchema;
